var _polygon, _polygon2, _polygon3, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorJewelry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "9.117 4.683 2.815 14.679 39.185 14.679 32.883 4.683 9.117 4.683"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "39.185 14.679 21 37.317 2.815 14.679 39.185 14.679"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "12.715 14.679 21 4.795 29.285 14.679 12.715 14.679"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.117,
    y1: 4.683,
    x2: 21,
    y2: 37.317
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32.883,
    y1: 4.683,
    x2: 21,
    y2: 37.317
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorJewelry);
export default __webpack_public_path__ + "static/media/indoor-jewelry.244a9498ff4f35e8880c339e9b7f4c5f.svg";
export { ForwardRef as ReactComponent };